import { render, staticRenderFns } from "./AtomLoadingSecondary.vue?vue&type=template&id=2cad9b64&"
import script from "./AtomLoadingSecondary.vue?vue&type=script&lang=js&"
export * from "./AtomLoadingSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports